export default "images/warning.png";